<pv-toolbar
	backAction="custom"
	icon="fa-chevron-left"
	[title]="'medication.found_medication_incidents.title' | language"
	(back)="goBack()"
/>

@if (medicationIncident(); as incident) {
	<ic-found-medication-incident-summary [medicationIncident]="incident" />
} @else {
	<loading-indicator [running]="true" />
}
